class Storage {
  static setToken = (token) => {
    try {
      return localStorage.setItem("@token", token);
    } catch (e) {
      return null;
    }
  };

  static getToken = () => {
    try {
      return localStorage.getItem("@token");
    } catch (e) {
      return null;
    }
  };

  static removeToken = () => {
    try {
      return localStorage.removeItem("@token");
    } catch (e) {
      return null;
    }
  };

  static setERole = (key, value) => {
    try {
      var Value = btoa(value);

      return localStorage.setItem(key, Value);
    } catch (e) {
      return null;
    }
  };
  static getERole = (key) => {
    try {
      const data = localStorage.getItem(key);

      return JSON.parse(atob(data));
    } catch (e) {
      return null;
    }
  };
  static setRole = (key, value) => {
    try {
      let Value = value.slice(1, value.length - 1);
      return localStorage.setItem(key, Value);
    } catch (e) {
      return null;
    }
  };

  static setUser = (key, value) => {
    try {
      if (typeof value !== "string") {
        value = JSON.stringify(value);
      }

      var Value = btoa(value);
      return localStorage.setItem(key, Value);
    } catch (e) {
      return null;
    }
  };
  static getUser = (key) => {
    try {
      const storedValue = localStorage.getItem(key);
      if (!storedValue) return null;

      const decodedValue = atob(storedValue);
      return JSON.parse(decodedValue);
    } catch (e) {
      return null;
    }
  };

  static removeUser = (key) => {
    try {
      return localStorage.removeItem("@user");
    } catch (e) {
      return null;
    }
  };

  static set = (key, value) => {
    try {
      return localStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
  };

  static get = (key) => {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  };

  static clearStorage = () => {
    try {
      localStorage.clear();
    } catch (e) {
      return null;
    }
  };

  static setLanguage = (value) => {
    try {
      return localStorage.setItem("@selectedLanguage", value);
    } catch (e) {
      return null;
    }
  };
  static setAssetsColumns = (key, value) => {
    try {
      if (typeof value !== "string") {
        value = JSON.stringify(value);
      }

      var Value = btoa(value);
      return localStorage.setItem(key, Value);
    } catch (e) {
      return null;
    }
  };
  static getAssetsColumns = (key) => {
    try {
      const storedValue = localStorage.getItem(key);
      if (!storedValue) return null;

      const decodedValue = atob(storedValue);
      return JSON.parse(decodedValue);
    } catch (e) {
      return null;
    }
  };
  static removeAssetsColumns = (key) => {
    try {
      return localStorage.removeItem("@assetcolumns");
    } catch (e) {
      return null;
    }
  };
  static setRedirect_URL = (value) => {
    try {
      return localStorage.setItem("@redirect_url", value);
    } catch (e) {
      return null;
    }
  };
  static getRedirect_URL = () => {
    try {
      return localStorage.getItem("@redirect_url");
    } catch (e) {
      return null;
    }
  };
}

export default Storage;
